import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GeoCoordService {
  constructor(private http: HttpClient) {}

  public getAddresses(searchString: string): Observable<any[]> {
    let url = environment.addressesApi + '?q=' + searchString + '&lat=45.756767&lon=4.831564&limit=10';
    return this.http.get(url).pipe(
      map(
        (response: any) =>
          response.features?.map((feature: any) => ({
            geometry: {
              coordinates: {
                lon: feature.geometry.coordinates[0],
                lat: feature.geometry.coordinates[1],
              },
            },
            properties: {
              label: feature.properties.label,
              housenumber: feature.properties.housenumber,
              name: feature.properties.name,
              postcode: feature.properties.postcode,
              citycode: feature.properties.citycode,
              city: feature.properties.city,
              street: feature.properties.street,
            },
          })) || [],
      ),
      catchError(() => of([])),
    );
  }
}
